import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import ProgressBar from '../../Components/application/ProgressBar';
import UploadSection from '../../Components/application/UploadSection';

export const VCApplyPage: React.FC = () => {
  const [status, setStatus] = useState<number>(0);
  const [showMetadata, setShowMetadata] = useState<boolean>(false);
  const history = useHistory();

  const progressStep =
    status === 0 ? 0 : status === 1 && !showMetadata ? 1 : status === 1 && showMetadata ? 2 : 3;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [status, showMetadata]);

  return (
    <>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px', marginBottom: '8px' }}>
        <h1 style={{ margin: 0 }}>憑證申請</h1>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/vc/help')}
        >
          查看使用說明 ↗
        </button>
      </div>
      <p className="dc-lead">
        依序完成四個步驟，將憑證存入數位憑證皮夾。
      </p>

      <div style={{ display: 'flex', justifyContent: 'center', margin: '30px 0 40px' }}>
        <ProgressBar status={progressStep} />
      </div>

      <div style={{ background: 'var(--dc-bg)', borderRadius: 'var(--dc-radius)', padding: '24px 16px' }}>
        <UploadSection
          status={status}
          setStatus={setStatus}
          showMetadata={showMetadata}
          setShowMetadata={setShowMetadata}
        />
      </div>

      <div className="dc-actions" style={{ marginTop: '36px' }}>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/vc')}
        >
          返回功能總覽
        </button>
      </div>
    </>
  );
};

export default VCApplyPage;
